import React, { useState } from 'react';

const ShowHide = ({ showInitially = false, renderTrigger = null, children }) => {
    const [isShowing, setIsShowing] = useState(showInitially);

    return (
    <>
        <button className="btn-no-appearance" onClick={() => setIsShowing(!isShowing)}>
            {
                renderTrigger 
                    ? renderTrigger(isShowing) 
                    : (
                        <span className="link-emulate">
                            { isShowing ? 'hide' : 'show' }
                        </span>
                    )
            }
        </button>
        { isShowing ? children : null }
    </>
    );
};

export default ShowHide;
